import { render, staticRenderFns } from "./vipssStudentCapterStatistics.vue?vue&type=template&id=0cc0ed62&scoped=true&"
import script from "./vipssStudentCapterStatistics.vue?vue&type=script&lang=js&"
export * from "./vipssStudentCapterStatistics.vue?vue&type=script&lang=js&"
import style0 from "./vipssStudentCapterStatistics.vue?vue&type=style&index=0&id=0cc0ed62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc0ed62",
  null
  
)

export default component.exports